(function () {
  'use strict';

  var modal, imageEl, titleEl, priceEl, descEl,
      sizesWrap, sizeOptionsEl, qtyInput, qtyDecrease, qtyIncrease,
      addButton, addLabelEl, errorEl;
  var selectedVariantId = null;
  var currentIsHe = false;

  function renderSizeOptions(variants) {
    sizeOptionsEl.innerHTML = '';
    variants.forEach(function (v) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'quick-view-modal--size-option';
      btn.textContent = v.title;
      if (!v.available) btn.disabled = true;
      btn.addEventListener('click', function () {
        selectedVariantId = v.id;
        errorEl.hidden = true;
        Array.prototype.forEach.call(
          sizeOptionsEl.querySelectorAll('.quick-view-modal--size-option'),
          function (b) { b.classList.toggle('is-selected', b === btn); }
        );
      });
      sizeOptionsEl.appendChild(btn);
    });
  }

  function openModal(data) {
    var variants = data.variants || [];
    currentIsHe = !!data.isHe;
    selectedVariantId = null;

    imageEl.src = data.image;
    imageEl.alt = data.title;
    titleEl.textContent = data.title;
    priceEl.textContent = data.price;
    descEl.textContent = data.description;
    errorEl.hidden = true;
    qtyInput.value = '1';

    if (variants.length > 1) {
      sizesWrap.hidden = false;
      renderSizeOptions(variants);
    } else {
      sizesWrap.hidden = true;
      if (variants[0]) selectedVariantId = variants[0].id;
    }

    addLabelEl.textContent = (currentIsHe ? 'הוספה לסל — ' : 'Add to bag — ') + data.price;

    modal.hidden = false;
    document.body.classList.add('quick-view-open');
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('quick-view-open');
  }

  // Post straight to Shopify's Cart AJAX API with the explicit variant id.
  //
  // This deliberately does NOT go through theme.partials.cart.addToCart.
  // That path was losing the selected variant: picking three different sizes
  // produced a single cart line of one size with quantity 3, even though the
  // data attached to each size button carried the correct, distinct variant
  // id. Posting the id ourselves removes the ambiguity entirely.
  //
  // On success we fire cart:added; the cart drawer listens for it, reloads
  // the cart and slides open. The drawer also owns the header count sync, so
  // there is no separate counter update here.
  function submitAdd() {
    if (!selectedVariantId) {
      errorEl.hidden = false;
      return;
    }

    var quantity = parseInt(qtyInput.value, 10) || 1;
    addButton.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: selectedVariantId, quantity: quantity }]
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add-to-cart failed');
        return res.json();
      })
      .then(function () {
        addButton.disabled = false;
        closeModal();
        document.dispatchEvent(new CustomEvent('cart:added'));
      })
      .catch(function () {
        addButton.disabled = false;
        errorEl.hidden = false;
      });
  }

  function boot() {
    modal = document.querySelector('[data-quick-view-modal]');
    if (!modal) return;

    imageEl = modal.querySelector('[data-quick-view-image]');
    titleEl = modal.querySelector('[data-quick-view-title]');
    priceEl = modal.querySelector('[data-quick-view-price]');
    descEl = modal.querySelector('[data-quick-view-description]');
    sizesWrap = modal.querySelector('[data-quick-view-sizes]');
    sizeOptionsEl = modal.querySelector('[data-quick-view-size-options]');
    qtyInput = modal.querySelector('[data-quick-view-qty-input]');
    qtyDecrease = modal.querySelector('[data-quick-view-qty-decrease]');
    qtyIncrease = modal.querySelector('[data-quick-view-qty-increase]');
    addButton = modal.querySelector('[data-quick-view-add]');
    addLabelEl = modal.querySelector('[data-quick-view-add-label]');
    errorEl = modal.querySelector('[data-quick-view-error]');

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quick-view-trigger]');
      if (trigger) {
        if (trigger.disabled) return;
        var wrap = trigger.closest('[data-quick-add]');
        var script = wrap && wrap.querySelector('[data-quick-view-data]');
        if (!script) return;
        var data;
        try {
          data = JSON.parse(script.textContent);
        } catch (err) {
          return;
        }
        openModal(data);
        return;
      }
      if (e.target.closest('[data-quick-view-close]')) {
        closeModal();
      }
    });

    qtyDecrease.addEventListener('click', function () {
      qtyInput.value = String(Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1));
    });
    qtyIncrease.addEventListener('click', function () {
      qtyInput.value = String((parseInt(qtyInput.value, 10) || 1) + 1);
    });
    addButton.addEventListener('click', submitAdd);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
